import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import useDynamicRefs from "use-dynamic-refs";
import {
  captchaChecked,
  pagesState,
  validateNumber,
  saveDateFrom,
  validateDate,
  formData,
  MyLibraryLogInAsync,
  myLibs,
} from "./controller";
import { current } from "@reduxjs/toolkit";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

export function MarriageForm() {
  const dispatch = useDispatch();
  const pages_state = useSelector(pagesState);
  const form_Data = useSelector(formData);
  const my_Libs = useSelector(myLibs);

  const [getRef, setRef] = useDynamicRefs();

  const [startDate, setStartDate] = useState(
    form_Data ? new Date(form_Data.SearchFromDate) : new Date("1961-09-14")
  );
  const [endDate, setEndDate] = useState(
    form_Data ? new Date(form_Data.SearchToDate) : new Date("1961-09-15")
  );

  const toggleDateChange = (date) => {
    dispatch(saveDateFrom(moment(date).format()));
    setStartDate(date);
    var endDate = new Date(date);
    setEndDate();
  };

  const toggleDateEndChange = (date) => {
    setEndDate(date);
    const datefrom = new Date(startDate);
    const dateto = new Date(date);
    const diffTime = Math.abs(dateto - datefrom);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays > 365 * 3) {
      var data = {
        is3years: false,
        days: diffDays,
      };
      dispatch(validateDate(data));
    } else {
      var data = {
        is3years: true,
        days: diffDays,
      };
      dispatch(validateDate(data));
    }
  };

  useEffect(() => {
    if (!sessionStorage.getItem("mdc")) {
      // window.location.href = "./marriage/disclaimer";
    }

    const redirectUrl = {
      CallBackUrl: process.env.REACT_APP_MARRIAGE_CALLBACKURL,
    };
    dispatch(MyLibraryLogInAsync(redirectUrl));
  }, []);

  const submitRequest = (e) => {
    e.preventDefault();

    if (
        getRef("recaptcha").current.getValue()
        && pages_state.isNumberCorrect &&
      pages_state.isDateWithin3Years
    ) {
      var formData = {
        RequestorName: getRef("name").current.value,
        RequestorEmail: getRef("email").current.value,
        // requestorInternationCode: getRef("firstNo").current.value,
        RequestorMobile: getRef("lastNo").current.value,
        HusbandName: getRef("nameofHusband").current.value,
        WifeName: getRef("nameofWife").current.value,
        // "SearchFromDate": getRef('dateofSearchFrom').current.value,
        // "SearchToDate": getRef('dateofSearchTo').current.value,
        SearchFromDate: moment(startDate).format("YYYY-MM-DD"),
        SearchToDate: moment(endDate).format("YYYY-MM-DD"),
        Remarks: getRef("remarks").current.value,
      };
      sessionStorage.setItem("mfs", JSON.stringify(formData));
      dispatch(captchaChecked(true));
      setTimeout(() => {
        window.location.href = "./marriage/summary";
      }, 500);
    } else if (!getRef("recaptcha").current.getValue()) {
      dispatch(captchaChecked(false));
    }
  };

  const verifyNumber = (e) => {
    if (e.target.value.length < 8) {
      dispatch(validateNumber(false));
    } else {
      dispatch(validateNumber(true));
    }
  };

  const checkDatePeriod = (e) => {
    switch (e.target.name) {
      case "DateofSearchFrom":
        document.getElementById("DateofSearchTo").value = "";
        dispatch(saveDateFrom(e.target.value));
        break;
      case "DateofSearchTo":
        const datefrom = new Date(getRef("dateofSearchFrom").current.value);
        const dateto = new Date(getRef("dateofSearchTo").current.value);
        const diffTime = Math.abs(dateto - datefrom);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays > 365 * 3) {
          var data = {
            is3years: false,
            days: diffDays,
          };
          dispatch(validateDate(data));
        } else {
          var data = {
            is3years: true,
            days: diffDays,
          };
          dispatch(validateDate(data));
        }

        break;
      default:
        break;
    }
  };

  const triggerForm = () => {
    window.wogaaCustom && window.wogaaCustom.startTransactionalService('ArchivesOnline-2858');
  }

  return (
    <section id="MarriageForm">
      <div className="container-fluid mt-3 form">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <img src="./images/icn-OnTopMarriage.png" alt="" />
                <h2 className="pageTitle mt-2">Marriage Record</h2>
                <div className="step py-3">
                  <div className="breadcrumbs">
                    <ul className="steps d-flex justify-content-center ">
                      <li>
                        <img src="./images/icon-form.png" alt="Step 1" />
                        <span className="theme-color">
                          <b>Form</b>
                        </span>
                      </li>
                      <li>
                        <img
                          src="./images/icon-payment-disabled.png"
                          alt="Step 2"
                        />
                        <span className="text-gray">Checkout & Payment</span>
                      </li>
                      <li>
                        <img
                          src="./images/icon-complete-disabled.png"
                          alt="Step 2"
                        />
                        <span className="text-gray">Complete</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <form onSubmit={(e) => submitRequest(e)}>
                <div className="card overflow-hidden">
                  <div className="card-header"></div>
                  <div className="card-body d-flex justify-content-center">
                    <div className="entryForm">
                      {my_Libs && !my_Libs.isMylibsLogin && (
                        <div className="mylibs mb-5">
                          <div className="theme-color fw-bold text-center">
                            Click here to login with your Mylibrary ID Account
                            to retrieve your information. If you do not have an
                            account, please fill in the form below with your
                            details.
                          </div>
                          <div className="d-flex justify-content-center mt-3">
                            <a
                              className="ui-theme-btn btn-mylibrary cursor_pointer"
                              title="Login using your NLB account."
                              target="_self"
                              href={pages_state ? pages_state.dataUrl : "#"}
                            >
                              <img
                                style={{ maxHeight: "31px", width: "auto" }}
                                src="./images/nlb-logo-white.svg"
                                alt=""
                              />{" "}
                              <span className="px-1">NLB myLibrary</span>{" "}
                              <span
                                style={{ fontSize: "20px" }}
                                className="material-icons-outlined align-middle"
                              >
                                chevron_right
                              </span>{" "}
                            </a>
                          </div>
                        </div>
                      )}

                      <div>
                        <h3 className="theme-color text-center">
                          Requestor's Particulars
                        </h3>

                        <div className="mb-3 row mt-3">
                          <label
                            htmlFor="name"
                            className="col-sm-2 col-form-label text-nowrap"
                          >
                            Name<span className="text-danger">*</span>:
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                form_Data
                                  ? form_Data.RequestorName
                                  : my_Libs
                                  ? my_Libs.RequestorNameFromLibs
                                  : ""
                              }
                              id="name"
                              ref={setRef("name")}
                              autoComplete="off"
                              required
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label
                            htmlFor="email"
                            className="col-sm-2 col-form-label text-nowrap"
                          >
                            Email<span className="text-danger">*</span>:
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="email"
                              defaultValue={
                                form_Data
                                  ? form_Data.RequestorEmail
                                  : my_Libs
                                  ? my_Libs.RequestorEmailFromLibs
                                  : ""
                              }
                              className="form-control"
                              ref={setRef("email")}
                              id="email"
                              autoComplete="off"
                              required
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label
                            htmlFor="LastNo"
                            className="col-sm-2 col-form-label text-nowrap"
                          >
                            Mobile No<span className="text-danger">*</span>:
                          </label>
                          <div className="col-sm-10 d-flex flex-row">
                            <div className="me-3">
                              <select
                                id="firstNo"
                                className="form-control"
                                ref={setRef("firstNo")}
                                defaultValue={
                                  form_Data
                                    ? form_Data.requestorInternationCode
                                    : ""
                                }
                              >
                                <option value="+65">+65</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                            <div style={{ flexBasis: "100%" }}>
                              <input
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                defaultValue={
                                  form_Data
                                    ? form_Data.RequestorMobile
                                    : my_Libs
                                    ? my_Libs.RequestorMobileFromLibs
                                    : ""
                                }
                                className={
                                  pages_state && pages_state.isNumberCorrect
                                    ? "form-control w-100"
                                    : "form-control w-100 is-invalid"
                                }
                                id="lastNo"
                                autoComplete="off"
                                onBlur={(e) => verifyNumber(e)}
                                ref={setRef("lastNo")}
                                required
                              />
                              {pages_state && !pages_state.isNumberCorrect && (
                                <div className="text-danger ">
                                  <small> At least 8 digits!</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card overflow-hidden mt-3">
                  <div className="card-header"></div>
                  <div className="card-body d-flex justify-content-center">
                    <div className="entryForm">
                      <div>
                        <h3 className="theme-color text-center">
                          Married Couple's Particulars
                        </h3>
                        <p className="text-center mb-4">
                          For requests to search for Muslim Marriage Records,
                          please contact the Registry of Muslim Marriages.
                        </p>
                        <div className="mb-3 row mt-3">
                          <label
                            htmlFor="NameofHusband"
                            className="col-sm-2 col-form-label text-wrap"
                          >
                            Name of Husband
                            <span className="text-danger">*</span>:
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              defaultValue={
                                form_Data ? form_Data.HusbandName : ""
                              }
                              className="form-control"
                              id="NameofHusband"
                              ref={setRef("nameofHusband")}
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                        <div className="mb-3 row mt-3">
                          <label
                            htmlFor="NameofWife"
                            className="col-sm-2 col-form-label text-wrap"
                          >
                            Name of Wife<span className="text-danger">*</span>:
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={form_Data ? form_Data.WifeName : ""}
                              id="NameofWife"
                              ref={setRef("nameofWife")}
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label
                            htmlFor="DateofSearchTo"
                            className="col-sm-2 col-form-label text-wrap"
                          >
                            Date of Search<span className="text-danger">*</span>
                            :
                          </label>
                          <div className="col-sm-10 d-flex flex-row flex-md-nowrap flex-wrap align-items-center">
                            <div
                              className="me-md-3 me-0"
                              style={{ flexBasis: "100%" }}
                            >
                              {/* <input type="date" name="DateofSearchFrom" defaultValue={form_Data ? form_Data.SearchFromDate : ''} className={pages_state && !pages_state.isDateWithin3Years ? 'form-control  is-invalid' : 'form-control'} id="DateofSearchFrom" max="1961-09-15" onBlur={(e) => checkDatePeriod(e)} ref={setRef('dateofSearchFrom')} required /> */}
                              <DatePicker
                                selected={startDate}
                                onChange={(date) => toggleDateChange(date)}
                                closeOnScroll={true}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                className={
                                  pages_state && !pages_state.isDateWithin3Years
                                    ? "form-control  is-invalid"
                                    : "form-control"
                                }
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date("1880-01-01")} // Sets the earliest selectable date
                                maxDate={new Date("1961-09-15")}
                                placeholderText="dd/mm/yyyy"
                                required
                              />
                            </div>
                            <div className="me-3">
                              <span>to:</span>
                            </div>
                            <div style={{ flexBasis: "100%" }}>
                              {/* <input type="date" name="DateofSearchTo" defaultValue={form_Data ? form_Data.SearchToDate : ''} className={pages_state && !pages_state.isDateWithin3Years ? 'form-control w-100 is-invalid ' : 'form-control w-100'} id="DateofSearchTo" ref={setRef('dateofSearchTo')} onBlur={(e) => checkDatePeriod(e)} min={pages_state && pages_state.dateFrom ? pages_state.dateFrom : ''} max="1961-09-15" required /> */}
                              <DatePicker
                                selected={endDate}
                                onChange={(date) => toggleDateEndChange(date)}
                                closeOnScroll={true}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                className={
                                  pages_state && !pages_state.isDateWithin3Years
                                    ? "form-control w-100 is-invalid "
                                    : "form-control w-100"
                                }
                                dateFormat="dd/MM/yyyy"
                                minDate={
                                  new Date(
                                    pages_state && pages_state.dateFrom
                                      ? pages_state.dateFrom
                                      : ""
                                  )
                                }
                                maxDate={new Date("1961-09-15")}
                                placeholderText="dd/mm/yyyy"
                                required
                              />
                            </div>
                          </div>

                          <div className="col-sm-10 offset-sm-2 mt-1">
                            {pages_state && !pages_state.isDateWithin3Years && (
                              <div className="text-danger ">
                                <small>
                                  You have selected more than 3 years!
                                </small>
                              </div>
                            )}
                            {pages_state && pages_state.isDateWithin3Years && (
                              <div>
                                <small>
                                  You have selected{" "}
                                  <b>{pages_state.selectDays}</b> days.
                                </small>
                              </div>
                            )}
                            <span className="material-icons-outlined align-middle me-1">
                              error_outline
                            </span>
                            <small>
                              The searchable date range is limited up to 3 years
                              period. NAS can only conduct a search of marriages
                              that occurred on/before 15 September 1961.
                            </small>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label
                            htmlFor="remarks"
                            className="col-sm-2 col-form-label text-nowrap"
                          >
                            Remarks:
                          </label>
                          <div className="col-sm-10">
                            <textarea
                              className="form-control"
                              defaultValue={form_Data ? form_Data.Remarks : ""}
                              rows="5"
                              id="remarks"
                              ref={setRef("remarks")}
                              placeholder="Tell us more about your request to help us conduct the search. (eg. Marriage register number, place/location of marriage)"
                            ></textarea>
                          </div>
                        </div>
                        {/* {process.env.REACT_APP_USERECAPTCHA === "true" && ( */}
                          <div className="mb-3 row mt-4">
                            <div className="col-sm-12 d-flex justify-content-center">
                              <ReCAPTCHA
                                sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                                ref={setRef("recaptcha")}
                              />
                            </div>
                            <div className="col-sm-12 d-flex justify-content-center">
                              {pages_state && !pages_state.isCaptcha && (
                                <div className="text-danger ">
                                  <small> Recaptcha is required!</small>
                                </div>
                              )}
                            </div>
                          </div>
                        {/* )} */}
                        <div className="mb-3 row">
                          <div className="col-sm-12 d-flex justify-content-center">
                            <button
                              type="submit"
                              className="btn btn-primary btn-lg me-2"
                              onClick={triggerForm}
                            >
                              Submit
                            </button>
                            <Link to={"/"} className="btn btn-secondary btn-lg">
                              Cancel
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
